import { type FormControlProps } from '@mui/base'
import { type FC, useId } from 'react'
import { type UseRefinementListProps } from 'react-instantsearch'
import { FormattedMessage } from 'react-intl'

import { IconSearch } from '@redteclab/icons'

import { FormControl, FormLabel, Input } from 'base-ui'

type ProductSearchRefinementTextInputProps = FormControlProps &
  Pick<UseRefinementListProps, 'attribute'> & {
    searchForItems?: (query: string) => void
  }

export const ProductSearchRefinementTextInput: FC<
  ProductSearchRefinementTextInputProps
> = ({ attribute, searchForItems, ...restProps }) => {
  const inputId = useId()

  return (
    <FormControl
      onChange={(event) => {
        if (searchForItems) {
          searchForItems(event.currentTarget.value)
        }
      }}
      {...restProps}
    >
      <FormLabel htmlFor={inputId}>
        <FormattedMessage id="general.button.label.search" />
      </FormLabel>
      <Input
        autoCapitalize="off"
        autoComplete="off"
        autoCorrect="off"
        endAdornment={<IconSearch className="size-6 fill-dark-brand" />}
        name={`search-options-${attribute}`}
        onBlur={(event) => {
          const { relatedTarget, target } = event

          if (
            relatedTarget instanceof HTMLLIElement &&
            relatedTarget.dataset.attribute === attribute
          ) {
            target.focus()
          }
        }}
        slotProps={{
          input: {
            'data-qa-id': `form-search-options-${attribute}`,
            id: inputId,
          },
        }}
        spellCheck={false}
      />
    </FormControl>
  )
}
